import { render } from "./NutmegPage.vue?vue&type=template&id=a6f64ce2"
import script from "./NutmegPage.vue?vue&type=script&lang=js"
export * from "./NutmegPage.vue?vue&type=script&lang=js"

import "@/assets/css/source-detail.css?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__